import React from "react";
import { Prompt } from "react-router";

const NGIPrompt = ({ show = true, text = "The changes will be unsaved. Do you want to discard it?" }) => (
  <Prompt when={show} message={text} />
);
export default NGIPrompt;
